<template>
  <div id="app">
    <Nav />
    <transition name="route" mode="out-in">
      <keep-alive include="Meteo,Calcul,Home">
        <router-view />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import Nav from "./components/Nav";
export default {
  name: "App",
  components: {
    Nav,
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

body,
html {
  overflow-x: hidden;
}
#app {
  min-height: 100vh;
  width: 100vw;
}
.route-enter,
.route-leave-to {
  opacity: 0;
  transform: translateX(5px);
}
.route-enter-active,
.route-leave-active {
  transition: all 0.25s ease;
}
.route-enter-to,
.route-leave {
  opacity: 1;
  transform: translateX(0);
}
</style>